/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircleChevronUp = createReactComponent("outline", "circle-chevron-up", "IconCircleChevronUp", [["path", { "d": "M9 13l3 -3l3 3", "key": "svg-0" }], ["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-1" }]]);

export { IconCircleChevronUp as default };
//# sourceMappingURL=IconCircleChevronUp.mjs.map
